import styled from 'styled-components'

export const ShrinkableBlock = styled.div`
  flex: 0 1 auto;
  width: 100%;
  overflow: hidden;
`
ShrinkableBlock.displayName = 'ShrinkableBlock'
